// extracted by mini-css-extract-plugin
module.exports = {"top":"Page_top__p4WIl","menu":"Page_menu__ssDKl","breadcrumbs":"Page_breadcrumbs__BvVlu"};